export const FETCH_CROSSING = 'crossings/FETCH_CROSSING'
export const CROSSING_ERROR = 'crossings/CROSSING_ERROR'
export const RECEIVE_CROSSINGS = 'crossings/RECEIVE_CROSSINGS'
export const RECEIVE_CROSSINGS_UNMODIFIED =
  'crossings/RECEIVE_CROSSINGS_UNMODIFIED'
export const crossingTypes = {
  DEPARTURE: 'departure',
  RETURN: 'return'
}
